import React from 'react';
import { Avatar, Table } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { tableColumnsOfTournamentPlayers } from '../../shared/utils/tournaments';
import { storageImage } from '../../shared/utils/storage-image';

export default function UserList({ users, onSelectPlayer }: {
  users: Users.User[];
  // eslint-disable-next-line no-unused-vars -- callback signature
  onSelectPlayer?: (user: Users.User) => void;
}) {
  return (
    <>
      <Table
        dataSource={users.map(item => ({ key: item.id, ['oyuncu-listesi']: item }))}
        columns={onSelectPlayer ? [{
          key: 'player',
          dataIndex: 'oyuncu-listesi',
          render: (player: Users.User) => (
            <button type="button" className="league-player-trigger" onClick={() => onSelectPlayer(player)}>
              <Avatar src={storageImage(player.foto_mini_url, 32)} icon={<UserOutlined />} />
              <span>{player.ad} {player.soyad}</span>
            </button>
          ),
        }] : tableColumnsOfTournamentPlayers}
        pagination={{ hideOnSinglePage: true, defaultPageSize: 8, showSizeChanger: false }}
        size="small"
        showHeader={false}
        tableLayout={onSelectPlayer ? 'fixed' : undefined}
        scroll={onSelectPlayer ? undefined : { x: 'max-content' }}
      />
    </>
  );
}

UserList.defaultProps = { onSelectPlayer: undefined };
